var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAiTrust4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22 31H24V57H22V31Z",
    fill: "#7986BF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6383 2H5.36174C3.5051 2 2 3.49859 2 5.34719V30.6528C2 32.5014 3.5051 34 5.36174 34H41.6383C43.4949 34 45 32.5014 45 30.6528V5.34719C45 3.49859 43.4949 2 41.6383 2Z",
    fill: "#CFE8FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6608 2H5.33916C3.49499 2 2 3.49859 2 5.34719V30.6528C2 32.5014 3.49499 34 5.33916 34H38.6608C40.505 34 42 32.5014 42 30.6528V5.34719C42 3.49859 40.505 2 38.6608 2Z",
    fill: "#E3F1FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M41.6383 54H5.36174C3.5051 54 2 55.4986 2 57.3472V82.6528C2 84.5014 3.5051 86 5.36174 86H41.6383C43.4949 86 45 84.5014 45 82.6528V57.3472C45 55.4986 43.4949 54 41.6383 54Z",
    fill: "#FDB0A0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6608 54H5.33916C3.49499 54 2 55.4986 2 57.3472V82.6528C2 84.5014 3.49499 86 5.33916 86H38.6608C40.505 86 42 84.5014 42 82.6528V57.3472C42 55.4986 40.505 54 38.6608 54Z",
    fill: "#FFCEC0"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4581 41.7566H70.9304C73.9415 42.7442 79.8066 43.7956 82.4962 45.3693C84.7197 46.6701 85.512 47.9981 85.7843 51.5323C86.214 59.3176 85.9302 66.4185 85.555 74H51.5007V56.4585C51.5007 55.1491 50.4819 54.0702 49.1721 53.9919C35.5958 53.1801 29.6301 45.3277 25.3949 36.4772C23.3089 32.118 30.0542 28.7327 32.39 32.8873C37.5236 42.0179 43.7681 46.4196 57.9857 41.7568H64.4579L64.4581 41.7566Z",
    fill: "#2A92FA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M54 43.0622C55.548 42.6861 57.0099 42.339 58.0962 42H70.9038C71.9901 42.339 73.452 42.6863 75 43.0622L74.2929 43.9829C71.9715 47.0057 68.5052 49 64.5 49C60.4948 49 57.0285 47.0057 54.7071 43.9829L54 43.0622Z",
    fill: "#0062D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57 41.7953C58.6424 40.8803 60.1488 39.0945 60.1488 35.6776V35H68.8514V35.6776C68.8514 39.0945 70.3578 40.8803 72 41.7953C70.1929 44.321 67.5604 46 64.5001 46C61.4397 46 58.8071 44.3209 57 41.7953Z",
    fill: "#F29988"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M68.7808 35V35.6776C68.7808 39.0945 70.321 40.8803 72 41.7953C70.1524 44.321 67.4609 46 64.332 46C62.3432 46 60.5311 45.3215 59 44.1785C60.5297 43.0221 62.1927 40.8312 62.1927 37.9321V35H68.7808Z",
    fill: "#FDB0A0"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65 40C53.2616 39.2402 50.1615 16 65 16C79.8385 16 76.7384 39.2402 65 40Z",
    fill: "#FDB0A0"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M64.4153 40C63.9479 39.9685 63.4963 39.8946 63.0582 39.7889C57.2558 34.6911 55.9155 21.3591 61.8421 16.2883C62.6285 16.1021 63.4841 16 64.4153 16C78.6375 16 75.6662 39.2404 64.4153 40Z",
    fill: "#FFCEC0"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M70.5599 16.3514C71.8709 15.8085 74.0512 16.4708 74.7798 19.4071C75.2216 21.1869 75.0289 25.6108 73.9246 28C72.7271 26.7186 72.4726 25.293 71.6802 24.097C71.0614 23.163 69.9692 23.4346 68.3309 24.0009C63.876 25.5412 59.2932 22.9816 57.0671 23.3802C55.2601 23.7036 54.8699 26.4214 54.5749 28C52.7005 25.9176 52.508 20.113 53.9505 15.4958C61.4652 16.651 67.5828 10.9822 70.5599 16.3514Z",
    fill: "#1A1A1A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M63 46H66V74H63V46Z",
    fill: "#0062D9"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76 75V55.5549C76 54.6962 76.6716 54 77.5 54C78.3284 54 79 54.6962 79 55.5549V75H76Z",
    fill: "#0062D9"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15328 25.2652C7.83856 24.7055 8.02401 23.9888 8.56733 23.6646C9.11064 23.3403 9.80636 23.5314 10.1211 24.0911L10.5848 24.9185L14.0547 21.3438C14.4997 20.8854 15.2213 20.8854 15.6663 21.3438C16.1112 21.8022 16.1112 22.5456 15.6663 23.004L11.1481 27.6586L11.1465 27.6569C11.0781 27.7272 10.9998 27.7898 10.9122 27.8421C10.3689 28.1663 9.67317 27.9753 9.35845 27.4155L8.15328 25.2652Z",
    fill: "#2DD62D"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2381 15C18.5543 15 18 14.473 18 13.8228C18 13.1727 18.5543 12.6456 19.2381 12.6456H36.646C37.3298 12.6456 37.8841 13.1727 37.8841 13.8228C37.8841 14.473 37.3298 15 36.646 15H19.2381ZM19.2381 10.3544C18.5543 10.3544 18 9.82732 18 9.17718C18 8.52704 18.5543 8 19.2381 8H36.7619C37.4457 8 38 8.52704 38 9.17718C38 9.82732 37.4457 10.3544 36.7619 10.3544H19.2381Z",
    fill: "#7986BF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1831 28C18.5297 28 18 27.473 18 26.8228C18 26.1727 18.5297 25.6456 19.1831 25.6456H35.8169C36.4703 25.6456 37 26.1727 37 26.8228C37 27.473 36.4703 28 35.8169 28H19.1831ZM19.1831 23.3544C18.5297 23.3544 18 22.8273 18 22.1772C18 21.527 18.5297 21 19.1831 21H35.8169C36.4703 21 37 21.527 37 22.1772C37 22.8273 36.4703 23.3544 35.8169 23.3544H19.1831Z",
    fill: "#7986BF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.15328 12.2654C7.83856 11.7057 8.02401 10.9889 8.56733 10.6647C9.11064 10.3405 9.80636 10.5315 10.1211 11.0913L10.5848 11.9185L14.0547 8.34381C14.4997 7.8854 15.2213 7.8854 15.6663 8.34381C16.1112 8.80222 16.1112 9.54561 15.6663 10.004L11.1481 14.6586L11.1465 14.6569C11.0781 14.7272 10.9998 14.7898 10.9122 14.8421C10.3689 15.1663 9.67317 14.9753 9.35845 14.4155L8.15328 12.2654Z",
    fill: "#2DD62D"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2381 68C18.5543 68 18 67.473 18 66.8228C18 66.1727 18.5543 65.6456 19.2381 65.6456H36.646C37.3298 65.6456 37.8841 66.1727 37.8841 66.8228C37.8841 67.473 37.3298 68 36.646 68H19.2381ZM19.2381 63.3544C18.5543 63.3544 18 62.8273 18 62.1772C18 61.527 18.5543 61 19.2381 61H36.7619C37.4457 61 38 61.527 38 62.1772C38 62.8273 37.4457 63.3544 36.7619 63.3544H19.2381Z",
    fill: "#C86F5C"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1831 81C18.5297 81 18 80.473 18 79.8228C18 79.1727 18.5297 78.6456 19.1831 78.6456H35.8169C36.4703 78.6456 37 79.1727 37 79.8228C37 80.473 36.4703 81 35.8169 81H19.1831ZM19.1831 76.3544C18.5297 76.3544 18 75.8273 18 75.1772C18 74.527 18.5297 74 19.1831 74H35.8169C36.4703 74 37 74.527 37 75.1772C37 75.8273 36.4703 76.3544 35.8169 76.3544H19.1831Z",
    fill: "#C86F5C"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0033 67.6563C9.54508 68.1146 8.80195 68.1146 8.34369 67.6563C7.88544 67.1981 7.88544 66.4549 8.34369 65.9967L9.84036 64.5L8.34369 63.0033C7.88544 62.5451 7.88544 61.8019 8.34369 61.3437C8.80195 60.8854 9.54508 60.8854 10.0033 61.3437L11.5 62.8404L12.9967 61.3437C13.4549 60.8854 14.1981 60.8854 14.6563 61.3437C15.1146 61.8019 15.1146 62.5451 14.6563 63.0033L13.1596 64.5L14.6563 65.9967C15.1146 66.4549 15.1146 67.1981 14.6563 67.6563C14.1981 68.1146 13.4549 68.1146 12.9967 67.6563L11.5 66.1596L10.0033 67.6563Z",
    fill: "#FF4D4D"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0033 80.6563C9.54508 81.1146 8.80195 81.1146 8.34369 80.6563C7.88544 80.1981 7.88544 79.4549 8.34369 78.9967L9.84036 77.5L8.34369 76.0033C7.88544 75.5451 7.88544 74.8019 8.34369 74.3437C8.80195 73.8854 9.54508 73.8854 10.0033 74.3437L11.5 75.8404L12.9967 74.3437C13.4549 73.8854 14.1981 73.8854 14.6563 74.3437C15.1146 74.8019 15.1146 75.5451 14.6563 76.0033L13.1596 77.5L14.6563 78.9967C15.1146 79.4549 15.1146 80.1981 14.6563 80.6563C14.1981 81.1146 13.4549 81.1146 12.9967 80.6563L11.5 79.1596L10.0033 80.6563Z",
    fill: "#FF4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiTrust4);
export default __webpack_public_path__ + "static/media/ai-trust-4.905f36132ee762f3b79b6565bfd5a3f0.svg";
export { ForwardRef as ReactComponent };